import React, { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const AddLandCTA = ({ onClick, variant = 'green', className = '' }) => {
  const [isHovered, setIsHovered] = useState(false);
  const isGreen = variant === 'green';
  const { t } = useLanguage();
  const baseClasses = 'rounded-lg flex items-center gap-2 text-base leading-none transition-colors';
  // Slightly narrower horizontal padding for green to reduce visual width
  const padClasses = isGreen ? 'px-2.5 py-2' : 'px-3 py-2';
  const colorClasses = isGreen
    ? 'bg-brand-green hover:bg-[#0D5A2D] text-white'
    : 'text-gray-900';

  return (
    <button 
      onClick={onClick} 
      className={`${padClasses} ${baseClasses} ${colorClasses} ${className}`}
      style={!isGreen ? { 
        backgroundColor: isHovered ? 'white' : '#FFCC08',
        border: isHovered ? '2px solid #12793C' : '2px solid transparent',
        transition: 'background-color 0.2s ease, border 0.2s ease'
      } : undefined}
      onMouseEnter={() => !isGreen && setIsHovered(true)}
      onMouseLeave={() => !isGreen && setIsHovered(false)}
    >
      <span className={`font-normal font-montserrat ${isGreen ? '' : 'text-gray-900'}`}>
        {t('cta.addYourLand')}
      </span>
    </button>
  );
};

export default AddLandCTA;
